import { useEffect } from 'preact/compat'
import { useDispatch } from 'react-redux'
import { transactionDetailsUpdate } from '../redux/slice/transactionDetailsSlice'

const MAX_VALUE_METADATA = 100
export const prepareMetadata = metadata =>
  metadata && metadata !== 'invalid' && metadata !== 'lengthError'
    ? metadata
    : undefined
export function getMetadataFromString(str) {
  if (str === '') return undefined
  try {
    if (str.startsWith('{')) {
      if (str.replace(/\s/g, '').length > MAX_VALUE_METADATA) {
        return 'lengthError'
      }
      return JSON.parse(str)
    }
    return 'invalid'
  } catch (e) {
    return 'invalid'
  }
}

export default function useMetadata(metadata) {
  const dispatch = useDispatch()
  const value = getMetadataFromString(metadata)
  useEffect(() => {
    dispatch(
      transactionDetailsUpdate({
        metadata: value,
      }),
    )
  }, [metadata])
}
